/****************************************************************************
 * COPYRIGHT (c) 2025 Harman Connected Services
 *
 * All rights reserved
 *
 * This software embodies materials and concepts which are
 * confidential to Ignite Product and is made available solely
 * pursuant to the terms of a written license agreement with
 * Ignite Product.
 *
 * Designed and Developed by Harman International Industries, Inc.
 ***************************************************************************/

import {
  GLOBAL_ADMIN_OVERVIEW_FAILURE,
  GLOBAL_ADMIN_OVERVIEW_SUCCESS,
  GLOBAL_ADMIN_OVERVIEW_REQUEST,
  FETCH_OVER_VIEW_DETAILS_REQUEST,
  FETCH_OVER_VIEW_DETAILS_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_FAILURE,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS,
  FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE,
  FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS,
} from "./GlobalAdminDashboardTypes";

const initialState = {
  loading: false,
  error: "",
  overviewDetails: {},
  globalOverviewDetails: {},
  applicationList: [],
};

const globalAdminDashboardReducer = (state = initialState, action) => {
  switch (action.type) {
    case GLOBAL_ADMIN_OVERVIEW_REQUEST:
    case FETCH_OVER_VIEW_DETAILS_REQUEST:
    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GLOBAL_ADMIN_OVERVIEW_SUCCESS:
      return {
        loading: false,
        globalOverviewDetails: action.payload,
        error: "",
      };
    case GLOBAL_ADMIN_OVERVIEW_FAILURE:
    case FETCH_OVER_VIEW_DETAILS_FAILURE:
      return {
        loading: false,
        overviewDetails: {},
        error: action.payload,
      };

    case FETCH_OVER_VIEW_DETAILS_SUCCESS:
      return {
        loading: false,
        overviewDetails: action.payload,
        error: "",
      };
    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_SUCCESS:
      return {
        ...state,
        loading: false,
        downloadOverViewData: action.payload,
        error: "",
      };
    case FETCH_OVER_VIEW_DETAILS_DOWNLOAD_FAILURE:
      return {
        ...state,
        loading: false,
        downloadOverViewData: {},
        error: action.payload,
      };
    case FETCH_GLOBAL_ADMIN_DOWNLOAD_SUCCESS:
      return {
        loading: false,
        globalAdminDownloadData: action.payload,
        error: "",
      };
    default:
      return state;
  }
};

export default globalAdminDashboardReducer;
